<template>
    <div>
        <b-badge
            :variant="$store.getters['user/level2variant'](model.level)"
            >{{
            trans.labels[
            'users.level.' + model.level
            ]
            }}</b-badge>
        <b-badge
            :variant="$store.getters['user/status2variant'](model.status)"
            >{{
            trans.labels[
            'users.status.' + model.status
            ]
            }}</b-badge>
<!--
        <font-awesome-icon icon="link" class="fa-fw" v-if="!model.is_public" />
-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'trans',
        ])
    },
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>

